import { render, staticRenderFns } from "./CustomerNotifications.vue?vue&type=template&id=12e2c2fd&scoped=true"
import script from "./CustomerNotifications.vue?vue&type=script&lang=js"
export * from "./CustomerNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotifications.vue?vue&type=style&index=0&id=12e2c2fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2c2fd",
  null
  
)

export default component.exports